<template>
  <div class="gestion-planes-container py-4">
    <!-- Cabecera con título y botón crear -->
    <div class="gestion-header d-flex justify-content-between align-items-center mb-4">
      <h2 class="gestion-title mb-0">
        <font-awesome-icon :icon="['fas', 'seedling']" class="me-2" />
        Gestión de Planes de Cultivo
      </h2>

      <!-- Botón Crear -->
      <button
        class="btn btn-sm btn-success d-flex align-items-center"
        @click="vista = 'crear'"
      >
        <font-awesome-icon :icon="['fas', 'plus']" class="me-2" />
        Nuevo Plan
      </button>
    </div>

    <!-- Contenido dinámico -->
    <div v-if="vista === 'crear'">
      <CrearPlanCultivo @cancelar="vista = 'listar'" />
    </div>
    <div v-else>
      <ListarPlanes />
    </div>
  </div>
</template>




<script>
import ListarPlanes from '@/components/PlanCultivo/listar-planesCultivo.vue';
import CrearPlanCultivo from '@/components/PlanCultivo/crearPlan/alta-planCultivo.vue';
import emitter from '@/mitt';

export default {
  name: 'PlanCultivoGestion',
  components: {
    ListarPlanes,
    CrearPlanCultivo
  },
  data() {
    return {
      vista: 'listar'
    };
  },
  methods: {
    cambiarVista(nuevaVista) {
      this.vista = nuevaVista;
    }
  },
  mounted() {
    emitter.on('cambiar-vista', this.cambiarVista);
  },
  beforeUnmount() {
    emitter.off('cambiar-vista', this.cambiarVista);
  }
};
</script>










  
<style scoped>
.gestion-planes-container {
  background-color: #ffffff;
  border-radius: 12px;
  padding: 2.5rem;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.gestion-header {
  border-bottom: 2px solid #ccc;
  padding-bottom: 1.5rem;
}

.gestion-title {
  font-size: 2rem;
  font-weight: 700;
  color: #333;
}

.btn-success {
  background-color: var(--app-primary);
  border: none;
  font-size: 0.95rem;
  padding: 0.6rem 1rem;
  border-radius: 30px;
}

.btn-success:hover {
  background-color: darken(var(--app-primary), 10%);
}

</style>
